var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcStatusMorningFill = function SvgIcStatusMorningFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.912 7.42V5.912a.912.912 0 0 0-1.825 0V7.42a.912.912 0 0 0 1.825 0M18.711 10.578l1.066-1.066a.912.912 0 1 0-1.29-1.29l-1.065 1.066a.912.912 0 1 0 1.29 1.29M20.58 15.912h1.508a.912.912 0 0 0 0-1.824H20.58a.912.912 0 1 0 0 1.824M3.42 15.912H1.912a.912.912 0 0 1 0-1.824H3.42a.912.912 0 1 1 0 1.824M6.578 9.288 5.512 8.223a.912.912 0 1 0-1.29 1.29l1.066 1.065a.912.912 0 1 0 1.29-1.29M11.999 9.754A6.245 6.245 0 0 0 5.755 16h12.49a6.246 6.246 0 0 0-6.246-6.246"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 18.9c0-.497.37-.9.825-.9h20.35c.456 0 .825.403.825.9s-.37.9-.825.9H1.825c-.456 0-.825-.403-.825-.9",
    clipRule: "evenodd"
  })));
};
export default SvgIcStatusMorningFill;